const home = {
  header: {
    titleLineOne:
      "Vocabulaire, grammaire, compréhension orale, expression et culture anglophone (niveaux A1, A2, B1 et B2 du CECRL)",
    titleLineOneBis:
      "Tests d’entraînement pour Ev{'@'}lang et certifications d’anglais.",
    titleLineTwo: "Activités variées et fiches de cours",
    titleLineThree: "Usage en classe et/ou à la maison",
    links: [
      "L'équipe iizenglish",
      "Comment ça marche ?",
      "On parle de nous",
      "Nous contacter",
    ],
  },
  moreInfo: "EN SAVOIR PLUS",
  gar_notice:
    "Veuillez passer par votre Espace Numérique de Travail pour accéder aux ressources.",
  origin_iizenglish: {
    title: "L’ORIGINE D’IIZENGLISH",
    firstLine: "iizenglish est né d’un double constat : ",
    liOne:
      "La différenciation pédagogique est essentielle, mais souvent difficile à mettre en oeuvre au quotidien",
    liTwo: "La mémorisation durable reste un défi pour de nombreux élèves",
    paragraphOne:
      "Nous avons donc créé un outil simple et intuitif, conçu par des enseignants pour des enseignants, afin de faciliter la différenciation et aider chaque élève à progresser à son rythme.",
    paragraphTwo:
      "Grâce à la répétition active intelligente, iizenglish transforme l’entraînement en une expérience d’apprentissage efficace et durable, où chaque exercice consolide les acquis tout en maintenant l’intérêt de nos élèves.",
  },
  offer: {
    title: "LES AVANTAGES DE NOTRE OFFRE",
    teacherTitle: "POUR LES ENSEIGNANTS",
    studentTitle: "POUR LES ÉLÈVES",
    forTeacherAdvantages: [
      "Création rapide d’un devoir à faire en cours ou à la maison, à partir d’un large choix d’exercices",
      "Possibilité de créer des groupes de travail au sein d’une même classe (en fonction des besoins ou du niveau)",
      "Envoi d’exercices différents ou d’un même exercice en modulant la difficulté",
      "Réception d’un bilan personnalisé",
    ],
    forStudentsAdvantages: [
      "Exercices immédiatement corrigés et notés",
      "Possibilité de recommencer plusieurs fois l’exercice avec des phrases différentes à chaque tentative",
      "De nombreuses illustrations, associées à un fichier audio, pour faciliter la mémorisation du lexique",
      "Seule la meilleure note est retenue",
    ],
  },
  plan: {
    allDevice: "DISPONIBLE SUR TOUT SUPPORT",
    howItWorks: "COMMENT ÇA MARCHE ?",
    plans: [
      "SUR ABONNEMENT UNIQUEMENT",
      "{price} TTC PAR ÉLÈVE / AN",
      "VERSION DÉMO DISPONIBLE",
    ],
  },
  footer: {
    cgu: "CONDITIONS GÉNÉRALES D’UTILISATION",
    legalNotices: "MENTIONS LÉGALES",
  },
  PrivacyPolicy: {
    title: "POLITIQUE DE CONFIDENTIALITÉ",
    ressourceUrl:
      "https://files.iizenglish.com/prod/ressources/fr/2023_11_23_Politique_de_confidentialite.pdf",
  },
};

export default home;
